/**
 * @desc 新品下单-审批
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.PlmNewOrderApprovalRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/order/approval`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
